import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { getContent } from '../utils/contentStore';
import { useLanguage } from '../utils/i18n';
interface Client {
  name: string;
  logoUrl?: string;
  initials: string;
}
// Palette matching the Hero swatch strip
const palette = ['#DC2626', '#B91C1C', '#ef4444', '#1e293b', '#334155', '#475569', '#7f1d1d', '#fca5a5', '#cbd5e1', '#111827', '#374151', '#6b7280', '#DC2626', '#B91C1C', '#334155', '#ef4444', '#1e293b', '#475569', '#7f1d1d', '#111827'];
export function ClientsSection({
  dark = false
}: {
  dark?: boolean;
}) {
  const [imgError, setImgError] = useState(false);
  const clientsData = getContent().clients;
  const {
    t
  } = useLanguage();
  // Map contentStore clients to the format expected by the component
  const clients: Client[] = clientsData.map(c => ({
    name: c.name,
    logoUrl: c.logoUrl || undefined,
    initials: c.name.substring(0, 2).toUpperCase()
  }));
  const isLight = !dark;
  return <Section id="clients" dark={dark} className={`overflow-hidden ${isLight ? 'bg-white border-y border-gray-100' : ''}`} data-id="element-58">
      
      <div className="text-center mb-12" data-id="element-59">
        <h2 className="text-gray-500 font-bold tracking-widest uppercase mb-3 text-sm" data-id="element-60">
          Наши рекомендации
        </h2>
        <h3 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 uppercase" data-id="element-61">
          Компании, которые <span className="text-red-600" data-id="element-62">нам доверяют</span>
        </h3>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5" data-id="element-63">
        {clients.map((client, index) => <ClientCard key={index} client={client} index={index} data-id="element-64" />)}
      </div>
    </Section>;
}
function ClientCard({
  client,
  index
}: {
  client: Client;
  index: number;
}) {
  const [imgError, setImgError] = useState(false);
  const showLogo = client.logoUrl && !imgError;
  const fillColor = palette[index % palette.length];
  // Determine if fill color is light (needs dark text/logo) or dark (needs light)
  const isLight = ['#f8fafc', '#e2e8f0', '#cbd5e1', '#fca5a5'].includes(fillColor);
  return <motion.div initial={{
    opacity: 0,
    y: 12
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.4,
    delay: index * 0.03,
    ease: 'easeOut'
  }} className="group relative flex flex-col bg-gray-50 rounded-sm border border-gray-100 hover:shadow-lg transition-all duration-300 cursor-default overflow-hidden" style={{
    '--fill-color': fillColor
  } as React.CSSProperties} data-id="element-65">
      
      {/* Paint fill overlay — slides up from bottom, each card its own color */}
      <div className="absolute inset-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]" style={{
      background: fillColor
    }} aria-hidden data-id="element-66" />
      

      {/* Logo / Initials */}
      <div className="relative z-10 flex-1 flex items-center justify-center p-5 min-h-[100px]" data-id="element-67">
        {showLogo ? <img src={client.logoUrl} alt={client.name} onError={() => setImgError(true)} className={`w-full h-full max-h-16 object-contain transition-all duration-300 ${isLight ? 'filter grayscale group-hover:grayscale-0' : 'filter grayscale group-hover:grayscale-0 group-hover:brightness-0 group-hover:invert'}`} data-id="element-68" /> : <span className={`font-heading font-bold text-3xl tracking-wider transition-colors duration-300 select-none ${isLight ? 'text-gray-300 group-hover:text-gray-800' : 'text-gray-300 group-hover:text-white/90'}`} data-id="element-69">
          
            {client.initials}
          </span>}
      </div>

      {/* Company name */}
      <div className="relative z-10 px-3 py-2.5 border-t border-gray-200 group-hover:border-white/20 transition-colors duration-300" data-id="element-70">
        <span className={`block text-xs font-medium text-center leading-tight transition-colors duration-300 text-gray-600 ${isLight ? 'group-hover:text-gray-900' : 'group-hover:text-white'}`} data-id="element-71">
          
          {client.name}
        </span>
      </div>
    </motion.div>;
}